import styled from 'styled-components';

export default styled.div.attrs(({ id, orientation }) => ({
  'data-apc-type': 'spacer',
  'data-apc-orientation': orientation,
  'data-testid': id,
}))`
  flex: 1 1 ${({ spacing }) => spacing}px !important;
`;
